export const taskKeys = {
    all: ['tasks'],
    list: (params) => ['tasks', 'list', params],
    detail: (id) => ['tasks', 'detail', id],
    reviewRounds: (id) => ['tasks', 'detail', id, 'review-rounds'],
};

export const eventKeys = {
    all: ['events'],
    list: (params) => ['events', 'list', params],
};

export const coordinationKeys = {
    seats: (params) => ['coordination', 'seats', params],
    attention: (params) => ['attention', params],
    attentionAll: ['attention'],
};
